
import { useVisualFormContext } from '../../../contexts/VisualFormContext';
import FilterRow from './FilterRow';
import './Filter.scss'

export const Filter = ({ selectedDataset }) => {
    const { visualObject } = useVisualFormContext();

    
    const filters = visualObject?.Filters?.length ? visualObject?.Filters : [{}];
    const filterableColumns = selectedDataset?.Columns.filter(x => x.CanFilter)
  
    const filterSeeds = filters?.map((filter, index) => {
        const selectedColumn = filterableColumns?.find(c => c?.FieldName === filter?.FieldName);
        return {
            filter,
            selectedColumn,
            format: selectedColumn?.Format ?? null,
            index
        };
    });

    return (
        filterSeeds.map(({ filter, selectedColumn, format, index }) => (
            <FilterRow
                key={index}
                filter={filter}
                selectedColumn={selectedColumn}
                format={format}
                index={index}
                filterableColumns={filterableColumns}
                filtersLength={filters?.length}
            />
        ))
    )
}